import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";
import { StatusCell } from "@/components/status/cell";

export default function Currencies() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            sortable: true,
        },
        {
            id: "budget_rate_inr",
            header: "INR(₹)",
            accessorKey: "budget_rate_inr",
        },
        {
            id: "budget_rate_usd",
            header: "USD($)",
            accessorKey: "budget_rate_usd",
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
    ];

    const fields = ["id", "name", "budget_rate_inr", "budget_rate_usd", "status"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="currencies"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Currencies</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Currencies"
                    endPoint="currencies"
                    columns={columns}
                    meta={{
                        fields,
                    }}
                    href={(item) => item.id}
                    rowClassName="h-13"
                />
            </div>
        </div>
    );
}
